import { useEffect, useState } from "react";

type UseLocalStorageEntryResponse = [
  value: string | null,
  setValue: (newValue: string) => void
];

const getLSInitialValue = (
  key: string,
  initValue: string | null = null
): string | null => {
  let initialValue = initValue;

  const lsValue = localStorage.getItem(key);
  if (lsValue !== null) {
    initialValue = lsValue;
  }

  return initialValue;
};

export const useLocalStorageEntry = (
  key: string,
  initialValue: string | null = null
): UseLocalStorageEntryResponse => {
  const [value, setValue] = useState<string | null>(
    getLSInitialValue(key, initialValue)
  );

  useEffect(() => {
    const lsValue = localStorage.getItem(key);
    if (lsValue !== null) {
      if (value !== lsValue && value !== null) {
        localStorage.setItem(key, value);
      }
    } else {
      if (value !== null) {
        localStorage.setItem(key, value);
      }
    }
  }, [value]);

  return [value, setValue];
};

export const useLocalStorageValue = (
  key: string,
  initialValue: string | null = null
): string | null => {
  const [value, setValue] = useLocalStorageEntry(key, initialValue);

  return value;
};
